import React from 'react';
import './WhyChoose.css';
import RevealOnScroll from './RevealOnScroll';

const reasons = [
  "Agile methodology with faster delivery cycles",
  "Cross-browser & device compatibility",
  "Clean, scalable, and maintainable codebase",
  "End-to-end security implementation",
  "Real-time data handling and dashboarding",
  "Proven UI/UX design principles",
  "Post-launch support and enhancements"
];

const WhyChoose = () => {
  return (
    <section className="why-choose-section">
      <div className="why-choose-inner">
        {/* Left text column */}
        <div className="why-choose-left">
          <RevealOnScroll>
            <h2 className="why-choose-title">Why Choose Cabptoid</h2>
            <p className="why-choose-subtitle">
              We combine strategy, engineering, and design to build reliable web applications that grow
              with your business.
            </p>
          </RevealOnScroll>

          <ol className="why-choose-list">
            {reasons.map((reason, index) => (
              <RevealOnScroll key={index} delay={index * 100}>
                <li className="why-choose-item">
                  <span className="item-number">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <span className="item-text">{reason}</span>
                </li>
              </RevealOnScroll>
            ))}
          </ol>
        </div>

        {/* Right image column */}
        <div className="why-choose-right">
          <RevealOnScroll delay={300}>
            <div className="why-choose-image-wrapper">
              <img
                src="https://images.unsplash.com/photo-1622979135225-d2ba269cf1ac?auto=format&fit=crop&q=80&w=900"
                alt="Why Choose Cabptoid"
                className="why-choose-img"
              />
              <div className="why-choose-img-label">Interactive</div>
            </div>
          </RevealOnScroll>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
